export default "__VITE_ASSET__h8zYU7Eo__"